import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["theme"];
import React, { useContext } from 'react';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext";
import { deprecatedPropWarning } from "../../deprecationWarnings";
import { Select } from "./Select";
import { SelectArrow } from "./SelectArrow";
import { SelectContainer } from "./SelectContainer";
export var FormSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    deprecatedPropWarning('theme', 'This component is intended to inherit its parent’s color set or color.');
  }

  var _useContext = useContext(KeyboardDetectionContext),
      isUsingKeyboard = _useContext.isUsingKeyboard;

  return /*#__PURE__*/React.createElement(SelectContainer, null, /*#__PURE__*/React.createElement(Select, Object.assign({
    ref: ref,
    isUsingKeyboard: isUsingKeyboard
  }, props)), /*#__PURE__*/React.createElement(SelectArrow, null));
});
/**
* **FormSelect** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormSelect) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-form-formselect--default) | [Encore](https://encore.spotify.net/web/components/form?format=figma-figma#formselect) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=423:844) |
*
* FormSelect allows the user to select one option from a long list of potential options and is used within a Form
*
* @example
* () => (
*  <FormSelect defaultValue="">
*    <option disabled value="">
*      Choose one
*    </option>
*    <option value="hello">Hello</option>
*    <option value="hola">Hola</option>
*    <option value="hej">Hej</option>
*    <option value="hallo">Hallo</option>
*  </FormSelect>
*);
*
*/

export default FormSelect;